import React, { useState } from 'react';
import "../styles/global.css";

function TicketsButton({ tickets, price , onClick }) {
    return (
      <div className="continue-button-container" onClick={onClick}>
        <span className="continue-text">Continue</span>
        <div className="ticket-info">
          {
              (tickets == 1) && <span className="ticket-count">{tickets} ticket</span>
          }
          {
              (tickets > 1) && <span className="ticket-count">{tickets} tickets</span>
          }
          <span className="ticket-price">₪{price * tickets}</span>
        </div>
      </div>
    );
  }

export default TicketsButton;